module.exports = __webpack_public_path__ + "img/decorator-guitar.f9d80e07.png";